import { render, staticRenderFns } from "./top-nav.vue?vue&type=template&id=b852231c&scoped=true"
import script from "./top-nav.vue?vue&type=script&lang=js"
export * from "./top-nav.vue?vue&type=script&lang=js"
import style0 from "./top-nav.vue?vue&type=style&index=0&id=b852231c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b852231c",
  null
  
)

export default component.exports